import { useEffect } from 'react';
import { Button, makeStyles, TextField } from '@material-ui/core';
import ICommonFormProps from '../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps';

import TitledContainer from '../TitledContainer';
import ChipItem, { IChipItem } from './ChipItem';
import useFormChipInput from './useFormChipInput';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {

    },
    chipListWrapper: {
        minHeight: "3rem",
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        listStyle: 'none',
        marginBottom: "1rem",
        backgroundColor: "#F1F1F1",
        border: `1px solid ${theme.palette.divider}`,
        transition: "0.2s ease-in-out",
        padding: "0.1rem"
    },
    chipListFocused: {
        backgroundColor: "#FFFFFF",
        border: `1px solid ${theme.palette.primary.main}`
    },
    inputWrapper: {
        boxSizing: "border-box",
        padding: "1rem",
        minWidth: "21rem",
        position: "relative",
        flexGrow: 2,
        display: "flex",
        alignItems: "center"
    },
    input: {
        width: "100%",
        marginRight: "1rem"
    },
    button: {
        marginLeft: "1rem",
        alignItems: "end"
    }
}));
  
interface IFormChipInput extends ICommonFormProps {
    title: string;
    keyName: string;
    placeholderText: string;
    itemValidation: (value: string) => boolean;
    prevChipList?:IChipItem[]
}

const FormChipInput = (props: IFormChipInput) => {

    const classes = useStyles();

    const { t } = useTranslation();

    const { 
        setValue, 
        keyName,
        title,
        placeholderText,
        itemValidation
    } = props;

    const {
        currentInputValue,
        setInputValue,
        chipList,
        removeItem,
        onKeyDown,
        onPaste,
        onBlur,
        setChipList
    } = useFormChipInput(itemValidation, props.prevChipList);

    useEffect(() => {
        setValue?.(keyName, chipList);
    }, [chipList, keyName, setValue])

    
    return (
        <div className={classes.root}>
            <TitledContainer
                title={title}
                titleButtons={
                    <Button
                        className={classes.button}
                        variant="contained"
                        size="small"
                        onClick={() => setChipList([])}
                        disabled={chipList.length < 1 || props.disabled}
                    >
                        {t("ui.chipInput.clearAll")}
                    </Button>
                }
            >
                <div>
                    {   chipList.length > 0 &&
                        <div
                            className={classes.chipListWrapper}
                        >
                            {
                                chipList.map((chipItem: IChipItem, index: number) => {
                                    return (
                                        <ChipItem 
                                            key={chipItem.displayText}
                                            displayText={chipItem.displayText}
                                            hasError={chipItem.hasError}
                                            onRemove={() => removeItem(index)}
                                        />
                                    )
                                })
                            }
                        </div>
                    }
                    <div className={classes.inputWrapper}>
                            <TextField
                                onChange={setInputValue}
                                onKeyDown={onKeyDown}
                                onPaste={onPaste}
                                onBlur={onBlur}
                                className={classes.input}
                                placeholder={placeholderText}
                                variant="outlined"
                                value={currentInputValue}
                                disabled={props.disabled}
                            />
                            <Button 
                                variant={"contained"}
                                onClick={(e: any) => onBlur(e)}
                                color={"primary"}
                                disabled={props.disabled}
                            >
                                {t("ui.chipInput.add")}
                            </Button>
                    </div>
                </div>
            </TitledContainer>
        </div>
    )
}

export default FormChipInput;